import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import KyruusDrawer from '@kyruus/drawer';
import { APP_DRAWER_WIDTH } from './constants';

export const BaseAppDrawer = styled(KyruusDrawer)`
  & .MuiDrawer-paper {
    width: ${APP_DRAWER_WIDTH}px;
    @media (max-width: ${fromTheme('screen_medium')}) {
      width: 100vw;
    }
  }
`;
